import React from "react";
import { View } from "react-native";
import CrouselWalkthrough from "./CrouselWalkthrough";

const WalkThrough = () => {
  return (
    <View style={{ flex: 1 }}>
      <CrouselWalkthrough />
    </View>
  );
};

export default WalkThrough;
